import { render, staticRenderFns } from "./ListShogTekiyo.vue?vue&type=template&id=23ea5d06&"
import script from "./ListShogTekiyo.vue?vue&type=script&lang=ts&"
export * from "./ListShogTekiyo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports